import { Injectable } from '@angular/core';
import { Question } from 'app/shared/models/question';
import { DacConfig } from 'app/shared/services/dac-config.service';
import { SsoCrossDomainMessenger } from 'app/shared/services/sso-cross-domain-messenger';

@Injectable()
export class QuestionActionService {

  constructor(private dacConfig:DacConfig, private crossDomainMessenger:SsoCrossDomainMessenger) { }

  handleAction(action:{action:string, question:Question, data:any}) {
    if (action.action == 'redirect' && action.data && action.data.url) {
      this.crossDomainMessenger.sendMessage('dac.redirect', {url: action.data.url});
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/reports/services/question-action.service.ts